module.exports = __webpack_public_path__ + "img/chevron-right-hover.bfc99337.svg";